import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";
import { Column } from "@tanstack/react-table";
import {
  SHMenuItem,
  SHMenuList,
  SHStack,
  SHTypography,
} from "@components/design-systems";
import { SortAscSVG, SortDescSVG } from "@components/svgs";
import React from "react";

type MSTableSortColumnMenuProps = {
  column: Column<ModelScreenerRow, any>;
};

export const MSTableSortMenu = ({
  column,
}: MSTableSortColumnMenuProps) => {
  const isSorted = column.getIsSorted();

  return (
    <SHMenuList sx={{ padding: 0 }}>
      <SHMenuItem
        sx={{ height: "38px" }}
        selected={isSorted === "asc"}
        onClick={() => {
          column.clearSorting();
          column.toggleSorting(false);
        }}
      >
        <SHStack spacing={1} direction="row" alignItems="center">
          <SortAscSVG />
          <SHTypography variant="body1">Sort ascending</SHTypography>
        </SHStack>
      </SHMenuItem>
      <SHMenuItem
        sx={{ height: "38px" }}
        selected={isSorted === "desc"}
        onClick={() => {
          column.clearSorting();
          column.toggleSorting(true);
        }}
      >
        <SHStack spacing={1} direction="row" alignItems="center">
          <SortDescSVG />
          <SHTypography variant="body1">Sort descending</SHTypography>
        </SHStack>
      </SHMenuItem>
    </SHMenuList>
  );
};
